export const initialState = {
	bundle: {
		status: true,
		message: "",
		data: [],
		count: "",
		sisa: "",
		limit: "",
		pages: "",
	},
	kunjungan: {
		status: true,
		message: "",
		data: [],
		count: "",
		sisa: "",
		limit: "",
		pages: "",
	},
	detail: {
		status: true,
		message: "",
		data: [],
		count: "",
		sisa: "",
		limit: "",
		pages: "",
	},
	loading: false,
};

export const actions = {
	CHANGE_BUNDLE: "CHANGE_BUNDLE",
	CHANGE_KUNJUNGAN: "CHANGE_KUNJUNGAN",
	CHANGE_DETAIL_HEADER: "CHANGE_DETAIL_HEADER",
	CHANGE_LOADING: "CHANGE_LOADING",
};
